"use strict";

import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
  namespaced: true,

  state() {
    return {
      subscriptionDetail: [],
    };
  },
  actions,
  mutations,
  getters,
};
